import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import commonLabels from "../../../common/labels/common_en.json";
import html2pdf from "html2pdf.js";

import label from "../../labels/administration_en.json";
import {
  getAdvertisementlistByYear,
  getYearList,
} from "../../../common/actions/commonActions";
import { getExamslistByAdvertisementId } from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";


const InterviewPTReports = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    setReloadItem(!reloadItem);
  }, []);
  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedList, setSelectedList] = useState("");
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [isSend, setIsSend] = useState(true);
  const [printFlag, setPrintFlag] = useState(true);
  const [isValue, setIsValue] = useState(false);
  const session = JSON.parse(sessionStorage.getItem("session"));
  let { examList, advertisementList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  const selecting = [
    {
      id: 1,
      name: "Interview Letter",
    },
    {
      id: 2,
      name: "Centre wise Interview Attendance List",
    },
    {
      id: 3,
      name: "Centre wise Interview Marks Statement",
    },
    {
      id: 4,
      name: "Telegram/ email / SMS",
    },
    {
      id: 5,
      name: "Centre wise Interview Alphabetical List",
    },
    {
      id: 6,
      name: "Interview Schedule List",
    },
    {
      id: 7,
      name: "Detailed Interview List",
    },
    {
      id: 8,
      name: "Interview absent List",
    },
    {
      id: 9,
      name: "Interview Marks Proof Reading",
    },
  ];
  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }

    // setSaveButtonFlag(true);
    //  dispatch({
    //   type:SET_QUALIFYING_CANDIDATES_LIST,
    //   payload:[]
    //  })
    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    examList.length = 0;
   
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
   
    // selectedValue && dispatch(getQualifyingCandidatesList(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onChangeList = (ele) => {
    let selectedValue = ele;
    setSelectedList(ele);
    if (selectedValue == 1) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
    if (selectedValue == 2) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
    if (selectedValue == 3) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
    if (selectedValue == 4) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      // setIsSend(true);
      setIsValue(true);
    }
    if (selectedValue == 5) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
    if (selectedValue == 6) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
    if (selectedValue == 7) {
      setSaveButtonFlag(false);
      setPrintFlag(false);
      setIsValue(false);
    }
  };

  // const genPdf = () => {

  //   let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>'+commonLabels.MPSC+'</h5><h5>'+getStatisticalReport.examName+'</h5><h5>'+label.RecommendedCandidates+'</h5></div>';
  //   const htmlContent = document.createElement('div');
  //   htmlContent.innerHTML = headerDiv;
  //   htmlContent.innerHTML += pdfRef.current.innerHTML;
  //   const examName = getStatisticalReport.examName;

  //   const options = {
  //     margin: [1, 0.4, 0.7, 0.4],
  //     filename: "RecommendationStatistical.pdf",
  //     image: { type: "jpeg", quality: 0.95 },
  //     html2canvas: { scale: 2, dpi: 300, letterRendering: true },
  //     jsPDF: {
  //       unit: "in",
  //       format: "a4",
  //       orientation: "portrait",
  //       compressPDF: true,
  //     },
  //   };

  //   html2pdf()
  //     .from(htmlContent)
  //     .set(options)
  //     .toPdf()
  //     .get("pdf")
  //     .then((pdf) => {
  //       const totalPages = pdf.internal.getNumberOfPages();

  //       for (let i = 1; i <= totalPages; i++) {
  //         pdf.setPage(i);

  //         const pageWidth = pdf.internal.pageSize.getWidth();
  //         const pageHeight = pdf.internal.pageSize.getHeight();
  //         const textWidth =
  //           (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
  //           pdf.internal.scaleFactor;
  //         const textX = pageWidth - textWidth - 1.2;
  //         const textY = 0.8;
  //         const currentDate = new Date();
  //         const formattedDate = currentDate.toLocaleDateString('en-GB', {
  //           day: '2-digit',
  //           month: '2-digit',
  //           year: 'numeric',
  //         }).split('/').join('/');

  //         const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
  //         const dateX = pageWidth - dateWidth;
  //         const dateY = 0.6;
  //         pdf.setFontSize(8);
  //         pdf.text(formattedDate, dateX, dateY);
  //         pdf.text(`Page No. ${i}`, dateX, textY)

  //         const ad = getStatisticalReport.advertisementNo;
  //         const headerText = `Advertisement No. ${ad}`;
  //         const headerX = 0.4;
  //         const headerY = 0.6;

  //         pdf.setFontSize(8);
  //         pdf.text(headerText, headerX, headerY);
  //       }

  //       pdf.save(`RecommendationStatistical_${examName}.pdf`);
  //     });
  // };

  const downloadPdf = () => {
    // genPdf();
    setSaveButtonFlag(true);
    setIsSend(false);
    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    setSelectedAdvert("");
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setIsValue(false);
    setReloadItem(!reloadItem);
    // dispatch({
    //   type: SET_ABSENTEE_LIST,
    //   payload: [],
    // });
    examList.length = 0;
    // setStatisticalData([]);
  };

  const onSubmit = () => {
    // dispatch(getStatisticalReportByExamId(selectedAdvertNo, selectedExam));

    // if (selectReportStatus == 1) {
    //   dispatch(
    //     getExaminersAndModeratorReportData(
    //       selectedExam,
    //       selectSubject,
    //       selectedSupervisor
    //     )
    //   );
    // } else if (selectReportStatus == 3) {
    //   dispatch(getAbsenteeListByExamIdSubId(selectedExam, selectSubject));
    // }

    setPrintFlag(false);
    setReloadItem(!reloadItem);
  };
  return (
    <div className="dashboardContentArea">
      <h5> {label.InterviewPTReports} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                        // <option key={index} value={element.id}>
                        //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                        // </option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                <div className="form-group col-md-3">
                  <label className="float-left">
                    {commonLabels.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    {commonLabels.ReportsType}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedlist"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onChangeList(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {selecting &&
                      selecting.length > 0 &&
                      selecting
                        // .filter(
                        //   (element) =>
                        //     element.isDeleted === false &&
                        //     element.isActive === true
                        // )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag}
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                  {isValue == true &&
                    (session.roleName === "superadmin" ||
                      session.roleName === "desk officer") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={isSend}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.Send}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InterviewPTReports;
